import React from 'react'

function Experiences(props) {
  const { dark } = props;

  return (
    <div className={`border rounded-lg ${dark ? 'text-white' : 'bg-white'} p-5 shadow-md shadow-purple-300`}>
      <p className="text-xl font-bold mb-3 border-b pb-3">Experiences</p>
      <div className='mb-3'>
        <p className='font-semibold'>SQA Instructor - Beginner Learning Academy <span className='italic font-normal'>(Online Learning Platform)</span></p>
        <p className='text-sm font-bold text-gray-500 mb-2'>Dec, 2025 - Present</p>
        <p>
          * Developed structured SQA course curriculum covering topics
          from basic to advanced level <br />
          * Created video lecture contents in Bangla covering Software
          Testing Basics, Manual Testing, Bug Reporting and Test
          Documentation <br />
          * Designed free learning resources including SQA Roadmap,
          Test Case, Bug Report Templates etc. <br />
          * Grew learning community to 500+ members across platforms <br />
        </p>
      </div>
      <div>
        <p className='font-semibold'>Software Developer - Freelance <span className='italic font-normal'>(Remote)</span></p>
        <p className='text-sm font-bold text-gray-500 mb-2'>Sep, 2023 - Jun, 2025</p>
        <p>
          * Designed and developed web application products tailored to
          client requirements <br />
          * Built responsive and dynamic systems using JavaScript,
          React.js, Node.js and MERN stack <br />
          * Collaborated directly with local clients to gather requirements
          and deliver solutions on time <br />
          * Maintained and improved existing web applications based on
          client feedback <br />
          * Managed the full software development lifecycle from
          planning to deployment <br />
        </p>
      </div>
    </div>
  )
}

export default Experiences
